import { UnitType } from 'entities/Contract';
import { InvoiceFrequencyType } from 'entities/Invoice';
import { TableFilterType } from 'features/TableFilter';

interface BoxListFilters {
  priceFrom?: number;
  priceTo?: number;
  squareFrom?: number;
  squareTo?: number;
  priceRateType?: InvoiceFrequencyType;
  floorId?: string;
  unitType: UnitType;
}

export const transformBoxesListFilters = ({
  priceFrom,
  priceTo,
  priceType,
  squareFrom,
  squareTo,
  floorId,
  unitType,
}: TableFilterType): BoxListFilters => {
  return {
    priceFrom: priceFrom?.value || undefined,
    priceTo: priceTo?.value || undefined,
    squareFrom: squareFrom?.value || undefined,
    squareTo: squareTo?.value || undefined,
    priceRateType: priceType?.value || undefined,
    floorId: floorId?.value || undefined,
    unitType: unitType?.value || undefined,
  };
};
